import React, { FC } from 'react';
import { LoadingScreenProps } from './LoadingScreen.types';
import { Container, SpinningImage, LoadingText } from './LoadingScreen.styles';
import { useI18n } from '../../hooks/useI18n';
import loadingImage from '../../assets/Kimera_Cargando.png';

export const LoadingScreen: FC<LoadingScreenProps> = React.memo(({ isLoading }) => {
  const { t } = useI18n();

  return (
    <Container $isVisible={isLoading} role="status" aria-live="polite" aria-busy={isLoading}>
      <SpinningImage src={loadingImage} alt="Kimera loading animation" />
      <LoadingText>{t('loading')}</LoadingText>
    </Container>
  );
});

LoadingScreen.displayName = 'LoadingScreen';
